"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadSceneSurfaceData = void 0;
var getSceneResources = function (scene) {
    var resources = {
        images: [],
        fonts: [],
    };
    scene.objects.forEach(function (object) {
        switch (object.type) {
            case 'IMAGE': {
                resources.images.push({ imageUrl: object.url });
                if (object.maskUrl) {
                    resources.images.push({ imageUrl: object.maskUrl });
                }
                break;
            }
            case 'TEXT': {
                resources.fonts.push({
                    fontUrl: object.fontUrl,
                    fontMetrics: object.fontMetrics,
                });
                break;
            }
        }
    });
    return resources;
};
var areSceneResourcesLoaded = function (resources, resourceContext) {
    var e_1, _a, e_2, _b;
    try {
        for (var _c = __values(resources.images), _d = _c.next(); !_d.done; _d = _c.next()) {
            var image = _d.value;
            if (!resourceContext.isImageLoaded(image.imageUrl)) {
                return false;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    try {
        for (var _e = __values(resources.fonts), _f = _e.next(); !_f.done; _f = _e.next()) {
            var font = _f.value;
            if (!resourceContext.isFontLoaded(font.fontUrl)) {
                return false;
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return true;
};
var loadSceneResources = function (resources, resourceContext) { return __awaiter(void 0, void 0, void 0, function () {
    var fontsPromise, imagesPromise;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                fontsPromise = Promise.all(resources.fonts.map(function (_a) {
                    var fontUrl = _a.fontUrl, fontMetrics = _a.fontMetrics;
                    return resourceContext.loadFont({ fontUrl: fontUrl, fontMetrics: fontMetrics });
                }));
                imagesPromise = Promise.all(resources.images.map(function (_a) {
                    var imageUrl = _a.imageUrl;
                    return resourceContext.loadImage(imageUrl);
                }));
                return [4 /*yield*/, Promise.all([fontsPromise, imagesPromise])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
var loadSceneSurfaceData = function (scene, resourceContext) {
    var resources = getSceneResources(scene);
    if (areSceneResourcesLoaded(resources, resourceContext)) {
        return { type: 'LOADED', data: { scene: scene } };
    }
    else {
        return loadSceneResources(resources, resourceContext).then(function () {
            return { type: 'LOADED', data: { scene: scene } };
        });
    }
};
exports.loadSceneSurfaceData = loadSceneSurfaceData;
